module.exports = __webpack_public_path__ + "img/line-bottom.80432d83.svg";